import React, {useState, useEffect} from 'react';
import {checkBlobExists} from '../../../ducks/data';
import {withTranslation} from 'react-i18next';
import _ from 'lodash';
import {AnchorLink, Icon, Btn, LineSpacer, ModalDialog} from '../../../ui-toolkit/index';

function FileViewFormatter({entity, t}) {
    const [thumbnailUrl, setThumbnailUrl] = useState(null);
    const [showFullModal, setShowFullModal] = useState(false);
    const isImg = _.get(entity, 'fileName', '').match(/.(jpg|jpeg|png|gif)$/i);

    useEffect(async () => {
        if (!isImg) return;
        let fileName = _.replace(entity.fileUrl, /\.[^/.]+$/, '');
        let thumbnailName = `${fileName}_thumbnail`;
        let thumbUrl = _.replace(entity.fileUrl, fileName, thumbnailName);

        if (await checkBlobExists(thumbUrl)) setThumbnailUrl(thumbUrl);
        else setThumbnailUrl(entity.fileUrl);
    }, []);

    if (_.isObject(entity)) {
        return (
            <>
                {isImg ? (
                    <>
                        {thumbnailUrl == null ? (
                            <p>{t('generalShared.loading')}</p>
                        ) : (
                            <div>
                                <img src={thumbnailUrl} style={{maxWidth: 150, maxHeight: 150}} />
                                <LineSpacer space="xsm">
                                    <Btn color="primary" type="button" onClick={() => setShowFullModal(true)}>
                                        <Icon name="visibility" />
                                        {t('generalShared.view')}
                                    </Btn>
                                    <AnchorLink
                                        ghost
                                        color="primary"
                                        href={entity.fileUrl}
                                        target="_blank"
                                        download
                                        rel="noreferrer">
                                        <Icon name="download" />
                                        {t('generalShared.download')}
                                    </AnchorLink>
                                </LineSpacer>
                            </div>
                        )}

                        {showFullModal && (
                            <ModalDialog show={true} onHide={() => setShowFullModal(false)} size="xl">
                                <ModalDialog.Body>
                                    <img src={entity.fileUrl} style={{maxWidth: '100%', maxHeight: '100%'}} />
                                </ModalDialog.Body>
                            </ModalDialog>
                        )}
                    </>
                ) : (
                    <div>
                        <span>{entity.fileName} </span>
                        <AnchorLink
                            ghost
                            color="primary"
                            href={entity.fileUrl}
                            target="_blank"
                            download
                            rel="noreferrer">
                            <Icon name="download" />
                            {t('generalShared.download')}
                        </AnchorLink>
                    </div>
                )}
            </>
        );
    }

    return '-';
}

export default withTranslation()(FileViewFormatter);
